import React from 'react'
import Nav from '../../components/Navigation/Nav'
import Left from '../../components/LeftSide/Left'
import FriendsProfileMiddle from '../../components/FriendsProfile/FriendsProfileMiddle'
import { useState } from 'react'
import Right from '../../components/RightSide/Right'
import "../FriendsId/FriendsId.css"

const FriendsId = ({friendProfile}) => {

  const [search,setSearch] =useState("")

  const [showMenu,setShowMenu] =useState(false)
  const [following,setFollowing] =useState("")

  return (
    <div className='interface'>
        <Nav 
             search={search}
             setSearch={setSearch}
             showMenu={showMenu}
             setShowMenu={setShowMenu}
             />
        <div className="home">
            <Left />
            <FriendsProfileMiddle friendProfile={friendProfile}/>
            <Right
              showMenu={showMenu}
              setShowMenu={setShowMenu}
              following={following}
              setFollowing={setFollowing}
            />
        </div>
    </div>
  )
}

export default FriendsId